import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { useStyles } from 'features/command-center/components/shared';

import { GPAC_TEAM, TEAM_COLUMN_NAME } from '../../productionBoard.constants';

import { ProductionTransactionByWeek } from './ProductionTransactionByWeek';

export const RecruiterExpandableRow = ({ columns, row, queryParams }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const toggleOpen = () => setOpen(!open);

  return (
    <>
      <TableRow hover>
        <TableCell />

        {columns.map(col => {
          if (col.options.display !== true) return null;

          const isNameColumn = col.name === TEAM_COLUMN_NAME;
          const isGpacRow = row.empNo === GPAC_TEAM;

          return (
            <TableCell key={col.name} align={isNameColumn ? 'left' : 'right'}>
              {!isGpacRow && isNameColumn && (
                <IconButton className={classes.expandableButton} size="small" onClick={toggleOpen}>
                  {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                </IconButton>
              )}
              <span className={classes.regularWeightRow}>
                {col?.options?.customBodyRender
                  ? col.options.customBodyRender(row[col.name])
                  : row[col.name]}
              </span>
            </TableCell>
          );
        })}
      </TableRow>

      {open && (
        <ProductionTransactionByWeek
          columns={columns}
          recruiters={row.empNo}
          queryParams={queryParams}
        />
      )}
    </>
  );
};
